import classNames from "classnames";
import { useContext } from "react";

import { Icon } from "src/app/components/icon/Icon";
import { ModalContext } from "src/contexts/ModalContext";

import modalCSS from "./Modal.module.css";

const AlertModal = () => {
  const contextValue = useContext(ModalContext);
  const active = contextValue?.active;
  const content = contextValue?.content;

  return (
    <>
      {active && content && (
        <div className={classNames("u-block", "u-pos-fixed", "u-z-index15", "u-w100", "u-h100 ", "u-bg-black", "u-bg-black-light", modalCSS.modal)}>
          <div className={classNames("u-h8", content.style)}>
            <div className="u-flex u-col-12 u-flex-items-center">
              <div className={classNames("u-col-1", modalCSS.iconContainer)}>
                <img alt="Info icon" src={content.icon}></img>
              </div>
              <div className={classNames("u-col-10", modalCSS.textContainer)}>
                <h4 className={classNames("u-m0", content.textStyle, modalCSS.textHeader)}>{content.header}</h4>
                <p className={classNames("u-m0", "u-t-f18p", content.textStyle, modalCSS.textParagraph)}>{content.text}</p>
              </div>
              <div className={classNames("u-t-f16p", "u-cursor-pointer", modalCSS.close)} onClick={contextValue?.close}>
                <Icon name="close-modal" className={content.textStyle} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AlertModal;
